import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';
import { Icon } from '@instinet-analytics/semantic-ui-components';

export default function PerformanceVsIndexHelp() {
    return (
        <IconTooltip>
            <div>
                This chart compares the price movement of the symbol versus that
                of an index. The price movement for both the symbol and index is
                calculated as the % change from previous close.
            </div>
            <div>
                This comparison helps to identify if price changes are
                attributed to a general market trend or symbol-specific
                movements.
            </div>
            <div>
                The Index can be changed in the chart configuration{' '}
                <Icon name="cog" />.
            </div>
        </IconTooltip>
    );
}
